import { ROUTES_ADMIN_API_BASE } from "@/config/apiConfig";
import { apiFetch } from "@/services/apiService";
import {
  fetchRoutesInformationMockJson,
  isRoutesInformationMockEnabled,
} from "@/utils/routesInformationMock";

export type GuestSummaryResponse = {
  totalGuestsWaiting: number;
  seatsNeeded: number;
  mostPopularRoutes: Array<{
    from: string;
    to: string;
    count: number;
  }>;
};

export type WaitingRoutesResponse = {
  routes: Array<{
    from: string;
    to: string;
    count: number;
    cards: Array<{
      date: string;
      time: string;
      purpose: string | null;
      seatsNeeded: number;
    }>;
  }>;
  otherRoutes: Array<{
    from: string;
    to: string;
    count: number;
    totalSeatsNeeded: number;
  }>;
};

export async function getGuestSummary(location?: string): Promise<GuestSummaryResponse> {
  const params = new URLSearchParams();
  const currentLocation = location?.trim();
  if (currentLocation) {
    params.set("location", currentLocation);
  }

  const query = params.toString();
  const url = `${ROUTES_ADMIN_API_BASE}/api/RoutesInformation/get-guestsummary${
    query ? `?${query}` : ""
  }`;

  const response = await apiFetch(url, {
    method: "GET",
    skipAuth: true,
    headers: {
      accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch guest summary (${response.status})`);
  }

  return response.json() as Promise<GuestSummaryResponse>;
}

export async function getWaitingRoutes(params: {
  fromCity?: string;
  toCity?: string;
  date?: string;
  page?: number;
}): Promise<WaitingRoutesResponse> {
  if (isRoutesInformationMockEnabled()) {
    return fetchRoutesInformationMockJson<WaitingRoutesResponse>("get-waiting-routes.json");
  }
  const query = new URLSearchParams();
  const fromCity = params.fromCity?.trim();
  const toCity = params.toCity?.trim();
  const date = params.date?.trim();

  if (fromCity) {
    query.set("fromCity", fromCity);
  }
  if (toCity) {
    query.set("toCity", toCity);
  }
  if (date) {
    query.set("date", date);
  }
  query.set("page", String(params.page ?? 1));

  const url = `${ROUTES_ADMIN_API_BASE}/api/RoutesInformation/get-waiting-routes?${query.toString()}`;
  const response = await apiFetch(url, {
    method: "GET",
    skipAuth: true,
    headers: {
      accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch waiting routes (${response.status})`);
  }

  return response.json() as Promise<WaitingRoutesResponse>;
}
